import { IState } from 'legacy/lut/store'

export const selectSectionSettingsState = (state: IState) => state.partner360.sectionSettings
